"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Rendall API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CapabilitiesToJSON = exports.CapabilitiesFromJSONTyped = exports.CapabilitiesFromJSON = exports.instanceOfCapabilities = void 0;
/**
 * Check if a given object implements the Capabilities interface.
 */
function instanceOfCapabilities(value) {
    var isInstance = true;
    isInstance = isInstance && "assets" in value;
    isInstance = isInstance && "canAccessAnalyzedData" in value;
    isInstance = isInstance && "canAccessCustomerCommunity" in value;
    isInstance = isInstance && "canAccessAnalyzedDataLite" in value;
    isInstance = isInstance && "canAccessRawData" in value;
    isInstance = isInstance && "canAccessManageRisk" in value;
    isInstance = isInstance && "canViewEscalations" in value;
    isInstance = isInstance && "canEditEscalations" in value;
    isInstance = isInstance && "canAccessDetectionLibrary" in value;
    isInstance = isInstance && "canAccessManageAwareness" in value;
    isInstance = isInstance && "canAccessIncidentResponse" in value;
    isInstance = isInstance && "canAccessSelfServiceReporting" in value;
    isInstance = isInstance && "canViewAllTickets" in value;
    isInstance = isInstance && "canViewAgent" in value;
    isInstance = isInstance && "canViewAllTelemetry" in value;
    isInstance = isInstance && "canViewScanner" in value;
    isInstance = isInstance && "canViewSensor" in value;
    isInstance = isInstance && "canViewCloudSensor" in value;
    isInstance = isInstance && "canViewVirtualAppliances" in value;
    isInstance = isInstance && "canViewScanSchedules" in value;
    isInstance = isInstance && "canManageContact" in value;
    isInstance = isInstance && "canManageAlertConfig" in value;
    isInstance = isInstance && "canCommentAllTickets" in value;
    isInstance = isInstance && "canAccessDataFlow" in value;
    isInstance = isInstance && "canUninstallAgent" in value;
    isInstance = isInstance && "canCreateCustomDashboards" in value;
    isInstance = isInstance && "canSaveQuery" in value;
    isInstance = isInstance && "dataExplorerRawLogSearch" in value;
    isInstance = isInstance && "detectionLibrary" in value;
    isInstance = isInstance && "resourceCenterCustomerCommunity" in value;
    isInstance = isInstance && "ticketsViewAll" in value;
    isInstance = isInstance && "hasActivateVlcAccess" in value;
    isInstance = isInstance && "canViewAgentSettings" in value;
    return isInstance;
}
exports.instanceOfCapabilities = instanceOfCapabilities;
function CapabilitiesFromJSON(json) {
    return CapabilitiesFromJSONTyped(json, false);
}
exports.CapabilitiesFromJSON = CapabilitiesFromJSON;
function CapabilitiesFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'assets': json['assets'],
        'canAccessAnalyzedData': json['canAccessAnalyzedData'],
        'canAccessCustomerCommunity': json['canAccessCustomerCommunity'],
        'canAccessAnalyzedDataLite': json['canAccessAnalyzedDataLite'],
        'canAccessRawData': json['canAccessRawData'],
        'canAccessManageRisk': json['canAccessManageRisk'],
        'canViewEscalations': json['canViewEscalations'],
        'canEditEscalations': json['canEditEscalations'],
        'canAccessDetectionLibrary': json['canAccessDetectionLibrary'],
        'canAccessManageAwareness': json['canAccessManageAwareness'],
        'canAccessIncidentResponse': json['canAccessIncidentResponse'],
        'canAccessSelfServiceReporting': json['canAccessSelfServiceReporting'],
        'canViewAllTickets': json['canViewAllTickets'],
        'canViewAgent': json['canViewAgent'],
        'canViewAllTelemetry': json['canViewAllTelemetry'],
        'canViewScanner': json['canViewScanner'],
        'canViewSensor': json['canViewSensor'],
        'canViewCloudSensor': json['canViewCloudSensor'],
        'canViewVirtualAppliances': json['canViewVirtualAppliances'],
        'canViewScanSchedules': json['canViewScanSchedules'],
        'canManageContact': json['canManageContact'],
        'canManageAlertConfig': json['canManageAlertConfig'],
        'canCommentAllTickets': json['canCommentAllTickets'],
        'canAccessDataFlow': json['canAccessDataFlow'],
        'canUninstallAgent': json['canUninstallAgent'],
        'canCreateCustomDashboards': json['canCreateCustomDashboards'],
        'canSaveQuery': json['canSaveQuery'],
        'dataExplorerRawLogSearch': json['dataExplorerRawLogSearch'],
        'detectionLibrary': json['detectionLibrary'],
        'resourceCenterCustomerCommunity': json['resourceCenterCustomerCommunity'],
        'ticketsViewAll': json['ticketsViewAll'],
        'hasActivateVlcAccess': json['hasActivateVlcAccess'],
        'canViewAgentSettings': json['canViewAgentSettings'],
    };
}
exports.CapabilitiesFromJSONTyped = CapabilitiesFromJSONTyped;
function CapabilitiesToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'assets': value.assets,
        'canAccessAnalyzedData': value.canAccessAnalyzedData,
        'canAccessCustomerCommunity': value.canAccessCustomerCommunity,
        'canAccessAnalyzedDataLite': value.canAccessAnalyzedDataLite,
        'canAccessRawData': value.canAccessRawData,
        'canAccessManageRisk': value.canAccessManageRisk,
        'canViewEscalations': value.canViewEscalations,
        'canEditEscalations': value.canEditEscalations,
        'canAccessDetectionLibrary': value.canAccessDetectionLibrary,
        'canAccessManageAwareness': value.canAccessManageAwareness,
        'canAccessIncidentResponse': value.canAccessIncidentResponse,
        'canAccessSelfServiceReporting': value.canAccessSelfServiceReporting,
        'canViewAllTickets': value.canViewAllTickets,
        'canViewAgent': value.canViewAgent,
        'canViewAllTelemetry': value.canViewAllTelemetry,
        'canViewScanner': value.canViewScanner,
        'canViewSensor': value.canViewSensor,
        'canViewCloudSensor': value.canViewCloudSensor,
        'canViewVirtualAppliances': value.canViewVirtualAppliances,
        'canViewScanSchedules': value.canViewScanSchedules,
        'canManageContact': value.canManageContact,
        'canManageAlertConfig': value.canManageAlertConfig,
        'canCommentAllTickets': value.canCommentAllTickets,
        'canAccessDataFlow': value.canAccessDataFlow,
        'canUninstallAgent': value.canUninstallAgent,
        'canCreateCustomDashboards': value.canCreateCustomDashboards,
        'canSaveQuery': value.canSaveQuery,
        'dataExplorerRawLogSearch': value.dataExplorerRawLogSearch,
        'detectionLibrary': value.detectionLibrary,
        'resourceCenterCustomerCommunity': value.resourceCenterCustomerCommunity,
        'ticketsViewAll': value.ticketsViewAll,
        'hasActivateVlcAccess': value.hasActivateVlcAccess,
        'canViewAgentSettings': value.canViewAgentSettings,
    };
}
exports.CapabilitiesToJSON = CapabilitiesToJSON;
